import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MenuSection from "@/components/MenuSection";
import Ordering from "@/components/Ordering";
import Catering from "@/components/Catering";
import Reviews from "@/components/Reviews";
import Marquee from "@/components/Marquee";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import AIAssistant from "@/components/AIAssistant";
import ExitIntent from "@/components/ExitIntent";
import SeoSchema from "@/components/SeoSchema";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App bg-cream text-ink">
      <SeoSchema />
      <Navbar />
      <main>
        <Hero />
        <MenuSection />
        <Ordering />
        <Catering />
        <Reviews />
        <Marquee />
        <Contact />
      </main>
      <Footer />
      <StickyMobileCTA />
      <AIAssistant />
      <ExitIntent />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
